import type { QueryClient } from "@tanstack/react-query";

const AGENT_QUERY_KEYS = [
  "chefStats",
  "site-fresh-data",
  "site-betonnages",
  "pending-reservations",
  "livraisons",
  "concrete-pour-detail",
  "site-calendar",
  "site-budget-analysis",
  "work-progress",
  "notifications",
] as const;

/**
 * Invalidate all dashboard queries after an agent action (order, reservation, etc.).
 * Centralizes the 3 scattered invalidation blocks from useVoiceAgent.
 */
export function invalidateAgentQueries(queryClient: QueryClient): void {
  for (const key of AGENT_QUERY_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
